import "../scss/plugins/_swiper.scss";

import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";
import { deepMerge, jsonToObject } from "./modules/helpers";

function swiperControlDataSelector(controlName = "", id = "") {
  const idValue = id ? '="' + id + '"' : "";
  return `[data-swiper-${controlName}${idValue}]`;
}

function swiperDefaultOption(id) {
  const options = {
    modules: [A11y, Navigation, Pagination, Autoplay],
    pagination: {
      el: swiperControlDataSelector("pagination", id),
      type: "fraction",
    },
    navigation: {
      prevEl: swiperControlDataSelector("button-prev", id),
      nextEl: swiperControlDataSelector("button-next", id),
    },
  };
  return options;
}

document.querySelectorAll("[data-swiper]").forEach((slider) => {
  const slideId = slider.id;
  if (!slideId) {
    console.warn("Warning: add ID attribute", slider);
  }
  const options = deepMerge(swiperDefaultOption(slideId), jsonToObject(slider.dataset.swiper));
  new Swiper(slider, options);
});
